import { StoreSelector } from '@editor/types';

import { PaymentStore } from './types';

export const paymentStoreSelector: StoreSelector<
  Omit<PaymentStore, 'payment'>
> = {
  stripe: (state) => state.stripe,
  stripeAccountCountry: (state) => state.stripeAccountCountry,
  status: (state) => state.status,
  errorKind: (state) => state.errorKind,
  transactionError: (state) => state.transactionError,
  actions: (state) => state.actions,
  billingInfo: (state) => state.billingInfo,
};
